import FeatureSwitcher, { FeatureBlockProps } from '@/components/FeatureBlock';
import Styled from '@/components/FeatureGroups/FeatureGroups.styled';
import { Container } from '@/components/layout/Container';
import { parseHtml } from '@/lib/parse-html';
import { FC, ReactNode } from 'react';

export type FeatureGroupsGroup = FeatureBlockProps & { descriptionHtml?: string };

export interface FeatureGroupsProps {
  heading?: string;
  description?: ReactNode;
  displayMode?: 'alternating' | 'left' | 'right';
  groups: FeatureGroupsGroup[];
}

const FeatureGroups: FC<FeatureGroupsProps> = (props) => {
  return (
    <Styled.Wrapper>
      {props.heading && (
        <Container>
          <Styled.Heading id="feature-group-heading">{props.heading}</Styled.Heading>
          {!!props.description ? (
            <Styled.Description id="feature-group-subheading">{props.description}</Styled.Description>
          ) : null}
        </Container>
      )}

      {props.groups.map((group, index) => {
        let isReversed: boolean;

        switch (props.displayMode) {
          case 'left':
            isReversed = false;
            break;
          case 'right':
            isReversed = true;
            break;
          case 'alternating':
          default:
            isReversed = index % 2 > 0;
        }

        return (
          <FeatureSwitcher key={group.id} reversed={isReversed} {...group}>
            {parseHtml(group.descriptionHtml)}
          </FeatureSwitcher>
        );
      })}
    </Styled.Wrapper>
  );
};

FeatureGroups.defaultProps = {
  displayMode: 'alternating',
};

export default FeatureGroups;
